// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s9ZIu6tT4EQ3yD2nTizG{align-items:center;gap:8px;padding:0 16px 0 8px;display:flex}.s9ZIu6tT4EQ3yD2nTizG.S8GupoNVDiUXHCd9_iA9{padding:0}.mbBG3iHtYkINoncOG7BA{justify-content:start;display:grid}.mbBG3iHtYkINoncOG7BA span{text-align:left}.mbBG3iHtYkINoncOG7BA .yQmev61SFzgfX62CgwBO{color:var(--content-primary-tertiary)}.zuPUcUK711gpGaoIC1V1{grid-template-columns:auto max-content;width:-webkit-fit-content;width:fit-content;display:grid}.MCQtR3sEjY8wBE3098Jv.ODf8AAXrvSYzNcEUQ_R5{background:var(--background-primary-inverted-primary)}.MCQtR3sEjY8wBE3098Jv{cursor:pointer;background:var(--gray-20);border-radius:50%;padding:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `s9ZIu6tT4EQ3yD2nTizG`,
	"fromAudioCard": `S8GupoNVDiUXHCd9_iA9`,
	"right": `mbBG3iHtYkINoncOG7BA`,
	"time": `yQmev61SFzgfX62CgwBO`,
	"title": `zuPUcUK711gpGaoIC1V1`,
	"audioBtn": `MCQtR3sEjY8wBE3098Jv`,
	"white": `ODf8AAXrvSYzNcEUQ_R5`
};
export default ___CSS_LOADER_EXPORT___;
